import { MenuVersionsItemsProps } from '.';

export const fallbackMenu: MenuVersionsItemsProps[] = [
  {
    name: 'Investimentos',
    description: null,
    url: null,
    icon: null,
    status: 'separator',
    order: 0,
    hasAccess: true,
    target: '_self',
    iconName: null,
  },
  {
    name: 'Minha Carteira',
    description: null,
    url: '/minha-carteira',
    icon: 'https://cdn.app.monett.co/medias/11403/92c4c0531252e6d55d198862f20fed7c/MdPieChartOutline.svg',
    status: 'visible',
    order: 1,
    hasAccess: true,
    target: '_self',
    iconName: 'PieChartOutline',
  },
  {
    name: 'Assessoria Renda Variável',
    description: null,
    url: '/assessoria-renda-variavel',
    icon: 'https://cdn.app.monett.co/medias/11407/aeecb6e2d281fb3528e865b0a489b6b1/MdOutlineGraphicEq.svg',
    status: 'visible',
    order: 5,
    hasAccess: true,
    target: '_self',
    iconName: 'GraphicEq',
  },
  {
    name: 'Conteúdos',
    description: null,
    url: null,
    icon: null,
    status: 'separator',
    order: 6,
    hasAccess: true,
    target: '_self',
    iconName: null,
  },
  {
    name: 'EQI Research',
    description: null,
    url: '/research',
    icon: 'https://cdn.app.monett.co/medias/11408/fb2cec265387d13bf5de519f7d46da38/MdOutlineImportantDevices.svg',
    status: 'visible',
    order: 7,
    hasAccess: true,
    target: '_self',
    iconName: 'ImportantDevicesOutline',
  },
  {
    name: 'Notícias',
    description: null,
    url: '/noticias',
    icon: 'https://cdn.app.monett.co/medias/11751/587b5f575b36ecc298ff2c11a2167e65/MdOutlineLocalCafe-bkp.svg',
    status: 'visible',
    order: 8,
    hasAccess: true,
    target: '_self',
    iconName: 'CupOutline',
  },
  {
    name: 'Cursos',
    description: null,
    url: '/cursos',
    icon: 'https://cdn.app.monett.co/medias/11409/aaa8e7b0aaa948495f4fdce29681f15e/MdOutlineSchool.svg',
    status: 'visible',
    order: 9,
    hasAccess: true,
    target: '_self',
    iconName: 'SchoolOutline',
  },
  {
    name: 'Eventos',
    description: null,
    url: '/eventos',
    icon: 'https://cdn.app.monett.co/medias/9620/33110299d6671d2bd29e0034da90d300/event-test02.svg',
    status: 'visible',
    order: 10,
    hasAccess: true,
    target: '_self',
    iconName: 'DrinkOutline',
  },
  {
    name: 'Filmes e Séries',
    description: null,
    url: '/filmes',
    icon: 'https://cdn.app.monett.co/medias/11410/b6b2708e9c446849e5c760287bfb3401/MdOutlineLiveTv.svg',
    status: 'visible',
    order: 11,
    hasAccess: true,
    target: '_self',
    iconName: 'LiveTvOutline',
  },
  {
    name: 'Serviços Exclusivos',
    description: null,
    url: null,
    icon: null,
    status: 'separator',
    order: 12,
    hasAccess: true,
    target: '_self',
    iconName: null,
  },
  {
    name: 'Seguro de Vida',
    description: null,
    url: '/seguro-vida',
    icon: 'https://cdn.app.monett.co/medias/11391/c18076a69d0c7f4a550aaacacc37e454/16-segurovida-shieldv2.svg',
    status: 'visible',
    order: 13,
    hasAccess: true,
    target: '_self',
    iconName: 'ShieldOutline',
  },
  {
    name: 'Empresarial',
    description: null,
    url: '/empresarial',
    icon: 'https://cdn.app.monett.co/menu/15-creditoempresarial-bussinesiconv2.svg',
    status: 'visible',
    order: 14,
    hasAccess: true,
    target: '_self',
    iconName: 'Building',
  },
  {
    name: 'Cartões',
    description: null,
    url: '/cartao-de-credito',
    icon: 'https://cdn.app.monett.co/medias/9465/0d9aaec05727fd7a8f690637c59fb63b/credit-card.svg',
    status: 'visible',
    order: 15,
    hasAccess: true,
    target: '_self',
    iconName: 'CardOutline',
  },
  {
    name: 'Câmbio',
    description: null,
    url: '/cambio',
    icon: 'https://cdn.app.monett.co/menu/14-cambio-databasev2.svg',
    status: 'visible',
    order: 16,
    hasAccess: true,
    target: '_self',
    iconName: 'ExchangeOutline',
  },
  {
    name: 'Aquisição de bens',
    description: null,
    url: '/aquisicao-de-bens',
    icon: null,
    status: 'visible',
    order: 17,
    hasAccess: true,
    target: '_self',
    iconName: 'KeyOutline',
  },
];
